// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n*:focus {\n\toutline: none;\n}\n.video-box-content img {\n\twidth: 100%;\n\theight: 100%;\n\t-o-object-fit: contain;\n\t   object-fit: contain;\n}\n.video-box-content [photo] {\n\tcursor: pointer;\n\tborder-radius: 4px;\n\toverflow: hidden;\n}\n.video-box-content [photo] img {\n\tmax-height: 120px;\n}\n.video-box-content [photo].active {\n\tborder: 5px solid #1878f3;\n\tbox-shadow: rgba(0, 0, 0, 0.35) 0px 5px 5px;\n}\n.video-box-content [left] [photo] {\n\tmargin-top: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
